import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { scrollTop } from "../../../functions";

import "./styles.css";

const LinkReadToo = ({ path, title }) => {
  return (
    <Link to={path} onClick={scrollTop} className="link-read-too d-flex mb-3">
      {title}
    </Link>
  );
};

LinkReadToo.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default LinkReadToo;
